import Slider from "react-slick";
import { MdOutlineKeyboardArrowRight, MdOutlineKeyboardArrowLeft } from "react-icons/md";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Carousel.scss";

const Carousel = ({
  data = [],
  CardComponent,
  slidesToShow = 4,
  autoplay = true,
  speed = 500,
  arrows = true,
  dots = false,
  color1, color2,
  customNextArrow,
  customPrevArrow,
  defaultArrows = true,
  upto1300 = 3,
  upto975 = 2,
  upto575 = 1,
  facultyImages
}) => {

  if (!CardComponent) {
    console.error("Carousel component requires a CardComponent prop.");
    return null;
  }

  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="customArrow nextArrow" onClick={onClick}>
        <MdOutlineKeyboardArrowRight style={{ fontSize: "30px", color: "white" }} />
      </div>
    );
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="customArrow prevArrow" onClick={onClick} style={{ backgroundColor: "white" }}>
        <MdOutlineKeyboardArrowLeft style={{ fontSize: "30px", color: "black" }} />
      </div>
    );
  };

  const settings = {
    dots,
    infinite: false,
    speed,
    slidesToShow,
    slidesToScroll: 1,
    autoplay,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows,
    nextArrow: arrows && defaultArrows ? <NextArrow /> : customNextArrow,
    prevArrow: arrows && defaultArrows ? <PrevArrow /> : customPrevArrow,
    responsive: [
      { breakpoint: 1300, settings: { slidesToShow: upto1300 } },
      { breakpoint: 975, settings: { slidesToShow: upto975 } },
      { breakpoint: 575, settings: { slidesToShow: upto575 } },
    ],
  };

  const customStyles = {
    marginBottom: "0px"
  }

  return (
    <section className="facultyMembersMainContainer" style={{ backgroundImage: `linear-gradient(${color1}, ${color2})` }}>
      <Slider {...settings} className="slider">
        {data.map((item, index) => (
          <CardComponent key={index} {...item} customStyles={customStyles} facultyImages={facultyImages} />
        ))}
      </Slider>
    </section>
  );
};

export default Carousel;
